import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileCheck2, Loader2, Plus, Trash2, Upload, UserRound } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, fileUrl } from "../lib/api";

export const emptyTraveler = (relation = "مرافق") => ({ name: "", relation, passport_number: "", nationality: "", birth_date: "", passport_expiry: "", attachment_id: null });

const F = ({ label, children }) => <label className="space-y-1"><span className="text-[11px] font-semibold text-slate-500">{label}</span>{children}</label>;

const TravelerCard = ({ t, i, onChange, onRemove }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => onChange({ ...t, [k]: v });
  const read = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const r = await api.uploadExtract(file, "الجواز");
      onChange({ ...t, attachment_id: r.attachment_id, name: t.name || r.name || "", passport_number: r.passport_number || t.passport_number,
        nationality: r.nationality || t.nationality, birth_date: r.birth_date || t.birth_date, passport_expiry: r.expiry_date || t.passport_expiry });
      toast.success("تم رفع الجواز وقراءة بياناته — راجعها");
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر رفع الجواز"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 rounded-xl border border-slate-200 bg-white p-3" data-testid={`flight-traveler-${i}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-sm font-bold text-slate-700"><UserRound className="h-4 w-4 text-sky-600" /> {i === 0 ? "الموظف" : `مرافق ${i}`}</p>
        <div className="flex items-center gap-1">
          <input ref={ref} type="file" accept="image/*,.pdf" className="hidden" onChange={(e) => { read(e.target.files?.[0]); e.target.value = ""; }} />
          {t.attachment_id
            ? <a href={fileUrl(t.attachment_id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-1 text-[11px] font-semibold text-emerald-700" data-testid={`flight-traveler-passport-${i}`}><FileCheck2 className="h-3.5 w-3.5" /> الجواز مرفق</a>
            : <span className="rounded-full bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700">لا يوجد جواز</span>}
          <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} className="h-7 gap-1 text-xs" data-testid={`flight-traveler-upload-${i}`}>
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />} {t.attachment_id ? "تغيير" : "رفع الجواز"}</Button>
          {i > 0 && <button type="button" onClick={onRemove} className="rounded p-1 text-rose-500 hover:bg-rose-50" data-testid={`flight-traveler-remove-${i}`}><Trash2 className="h-4 w-4" /></button>}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        <F label="الاسم (كما في الجواز)"><Input value={t.name} onChange={(e) => set("name", e.target.value)} className="h-9" data-testid={`flight-traveler-name-${i}`} /></F>
        {i > 0 && <F label="صلة القرابة"><Input value={t.relation} onChange={(e) => set("relation", e.target.value)} placeholder="زوجة / ابن…" className="h-9" data-testid={`flight-traveler-relation-${i}`} /></F>}
        <F label="رقم الجواز"><Input dir="ltr" value={t.passport_number} onChange={(e) => set("passport_number", e.target.value)} className="h-9" data-testid={`flight-traveler-passport-no-${i}`} /></F>
        <F label="الجنسية"><Input value={t.nationality} onChange={(e) => set("nationality", e.target.value)} className="h-9" /></F>
        <F label="تاريخ الميلاد"><Input type="date" value={t.birth_date} onChange={(e) => set("birth_date", e.target.value)} className="h-9" /></F>
        <F label="انتهاء الجواز"><Input type="date" value={t.passport_expiry} onChange={(e) => set("passport_expiry", e.target.value)} className="h-9" /></F>
      </div>
    </div>
  );
};

export const FlightTravelers = ({ list, setList }) => (
  <div className="space-y-2" data-testid="flight-travelers">
    {list.map((t, i) => (
      <TravelerCard key={i} t={t} i={i} onChange={(x) => setList(list.map((y, j) => (j === i ? x : y)))} onRemove={() => setList(list.filter((_, j) => j !== i))} />))}
    <Button type="button" variant="outline" size="sm" onClick={() => setList([...list, emptyTraveler()])} className="gap-1.5 border-dashed" data-testid="flight-add-traveler">
      <Plus className="h-4 w-4" /> إضافة مرافق</Button>
  </div>
);
